import { Observable, shareReplay } from 'rxjs';
import { TranslateLoader } from '@ngx-translate/core';

import { HttpClient } from '@angular/common/http';

import { ResponseInterface } from '@/app/shared/interfaces/response.interface';

export class AppTranslateLoader implements TranslateLoader {
  private static cache: Record<string, Observable<any>> = {};

  constructor(private readonly http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    if (AppTranslateLoader.cache[lang]) {
      return AppTranslateLoader.cache[lang];
    }

    const url = `./assets/i18n/${lang}.json`;

    const request = this.http.get<ResponseInterface<Record<string, string>>>(url).pipe(shareReplay(1));

    AppTranslateLoader.cache[lang] = request;

    return request;
  }
}
